// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import BookingFormController from "./booking_form_controller"
application.register("booking-form", BookingFormController)

import BulkMessageController from "./bulk_message_controller"
application.register("bulk-message", BulkMessageController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CommentController from "./comment_controller"
application.register("comment", CommentController)

import ContentBoxController from "./content_box_controller"
application.register("content-box", ContentBoxController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import EmployeeAvailabilityController from "./employee_availability_controller"
application.register("employee-availability", EmployeeAvailabilityController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import GliderController from "./glider_controller"
application.register("glider", GliderController)

import HeadroomController from "./headroom_controller"
application.register("headroom", HeadroomController)

import JobAdjustmentController from "./job_adjustment_controller"
application.register("job-adjustment", JobAdjustmentController)

import LinkToController from "./link_to_controller"
application.register("link-to", LinkToController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NestedFieldController from "./nested_field_controller"
application.register("nested-field", NestedFieldController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import NewsletterController from "./newsletter_controller"
application.register("newsletter", NewsletterController)

import PayslipExportController from "./payslip_export_controller"
application.register("payslip-export", PayslipExportController)

import PhoneController from "./phone_controller"
application.register("phone", PhoneController)

import RadioButtonToggleController from "./radio_button_toggle_controller"
application.register("radio-button-toggle", RadioButtonToggleController)

import ReportCardController from "./report_card_controller"
application.register("report-card", ReportCardController)

import RichtextController from "./richtext_controller"
application.register("richtext", RichtextController)

import ServiceDropdownController from "./service_dropdown_controller"
application.register("service-dropdown", ServiceDropdownController)

import TelegramCheckController from "./telegram_check_controller"
application.register("telegram-check", TelegramCheckController)

import TransactionStatusController from "./transaction_status_controller"
application.register("transaction-status", TransactionStatusController)

import TrixEmbedController from "./trix_embed_controller"
application.register("trix-embed", TrixEmbedController)

import WorkerSelectController from "./worker_select_controller"
application.register("worker-select", WorkerSelectController)
